module.exports = __webpack_public_path__ + "static/content_energieexperten-9140732b1dd7b7cfd92687c61b94d2c8.svg";